import axios from 'axios'

const api = axios.create({
  baseURL: '/tracer',
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
})

// The path names the kind of thing; the query names which one. Identifiers differ
// in number between kinds -- a harness has one, a DTC has an acronym and a code --
// so they all travel as query parameters.
export function apiGetRelatedContent({
  entityKind,
  vin,
  language,
  ...identifiers
}) {
  const params = new URLSearchParams({ vin })
  if (language) params.set('language', language)

  Object.entries(identifiers).forEach(([name, value]) => {
    if (value != null && value !== '') params.set(name, value)
  })

  return api
    .get(`/related-content/${entityKind}?${params.toString()}`)
    .then((resp) => resp.data)
}
